import { useState, useEffect } from 'react'
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Button,
  useTheme
} from '@mui/material'
import { ArrowBack } from '@mui/icons-material'

export default function PrivacyPage() {
  const theme = useTheme()
  const [content, setContent] = useState<string>('')
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const fetchPrivacy = async () => {
      try {
        const response = await fetch('/privacy_policy.md')
        const text = await response.text()
        setContent(text)
      } catch (error) {
        console.error('Failed to load privacy policy:', error)
        setContent('Failed to load privacy policy.')
      } finally {
        setIsLoading(false)
      }
    }

    fetchPrivacy()
  }, [])

  const handleBack = () => {
    window.history.back()
  }

  // Simple markdown to HTML conversion for basic formatting
  const formatContent = (text: string) => {
    return text
      .replace(/^# (.*$)/gim, '<h1>$1</h1>')
      .replace(/^## (.*$)/gim, '<h2>$1</h2>')
      .replace(/^### (.*$)/gim, '<h3>$1</h3>')
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      .replace(/\*(.*?)\*/g, '<em>$1</em>')
      .replace(/\n/g, '<br>')
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
        py: 4
      }}
    >
      <Container maxWidth="md">
        <Box sx={{ mb: 3 }}>
          <Button
            startIcon={<ArrowBack />}
            onClick={handleBack}
            sx={{
              color: 'white',
              '&:hover': {
                bgcolor: 'rgba(255, 255, 255, 0.1)'
              }
            }}
          >
            Back
          </Button>
        </Box>

        <Card>
          <CardContent sx={{ p: 4 }}>
            <Typography variant="h3" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
              Privacy Policy
            </Typography>

            {isLoading ? (
              <Typography>Loading privacy policy...</Typography>
            ) : (
              <Box
                sx={{
                  '& h1': {
                    fontSize: '2rem',
                    fontWeight: 'bold',
                    mt: 3,
                    mb: 2,
                    color: theme.palette.primary.main
                  },
                  '& h2': {
                    fontSize: '1.5rem',
                    fontWeight: 'bold',
                    mt: 2,
                    mb: 1,
                    color: theme.palette.primary.main
                  },
                  '& h3': {
                    fontSize: '1.25rem',
                    fontWeight: 'bold',
                    mt: 2,
                    mb: 1
                  },
                  '& p': {
                    mb: 2,
                    lineHeight: 1.6
                  }
                }}
                dangerouslySetInnerHTML={{
                  __html: formatContent(content)
                }}
              />
            )}
          </CardContent>
        </Card>
      </Container>
    </Box>
  )
}